const state = {
  showingModal: "",
}

const getters = {
  showingModal: (state) => state.showingModal,
}

const mutations = {
  setShowingModal: (state, modal) => (state.showingModal = modal),
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/modals.js